const HelpCenter = () => {
    return (
        <div className="container-custom py-12">
            <h1 className="text-3xl font-bold mb-4">Help Center</h1>
            <p className="text-gray-700 mb-6">
                Welcome to the Mugesh Media Help Center. We’re here to assist you with anything related to your cable or internet services.
            </p>
            <ul className="list-disc list-inside space-y-2">
                <li>How to pay your cable bill?</li>
                <li>How to change or upgrade your plan?</li>
                <li>Report issues with signal or connection.</li>
                <li>Request technician visit in rural areas.</li>
            </ul>
        </div>
    )
}

export default HelpCenter